/**
 * Меню и страницы по правам «Доступов» — правка №58 (Чат 5). [Claude] 2026-11-03
 *
 * Пока флаг «Роли и права» (admin_panel) выключен для человека — всё как раньше, по роли ERP.
 * Когда включён — пункт меню и страница видны, если есть право «смотреть» (любая область)
 * хотя бы на один раздел из списка. Пустой список — страница открыта всем (главная, профиль,
 * структура компании — решение Светы 03.11: структуру видят все).
 */

export const PATH_OBJECTS = {
    "/dashboard": [],
    "/profile": [],
    "/settings/menu": [],
    "/notifications": [],
    "/organization": [],
    "/ai-assistant": ["ai_assistant"],
    "/requests": ["requests"],
    "/vacancies": ["vacancies"],
    "/candidate-portrait": ["vacancies", "requests"],
    "/candidates": ["candidates"],
    "/candidate-documents": ["scans"],
    "/employee-contracts": ["employee_documents"],
    "/learning": ["learning"],
    "/employees": ["employees"],
    "/employees/access": ["users"],
    "/contacts": ["vacancies", "candidates"],
    "/tests": ["tests"],
    "/tests/adaptation": ["adaptation"],
    "/calendar": ["calendar"],
    "/events": ["calendar"],
    "/autopilot": ["autopilot"],
    "/analytics": ["reports"],
    "/calls": ["calls"],
    "/logs": ["logs"],
    "/departments": ["organization"],
    "/kpi": ["kpi"],
    "/blacklist": ["blacklist"],
    "/archive": ["archive"],
};

let current = { on: false, grants: new Set() };

/** rights: ответ /compliance/me или null. Включено, только если флаг admin_panel включён для человека. */
export function setCurrentRights(me) {
    const on = Boolean(me && me.flags && me.flags.admin_panel);
    current = { on, grants: new Set(on && Array.isArray(me.grants) ? me.grants : []) };
    return current;
}

export function rightsOn() {
    return current.on;
}

export function canView(object, grants = current.grants) {
    const prefix = `${object}:view:`;
    for (const g of grants) if (String(g).startsWith(prefix)) return true;
    return false;
}

/** Раздел для адреса: самый длинный совпавший префикс (с учётом подстраниц). */
export function objectsForPath(path) {
    const clean = String(path || "").split("?")[0].replace(/\/+$/, "") || "/";
    if (/^\/vacancies\/[^/]+\/cold-search$/.test(clean)) return ["candidates"];
    let best = null;
    for (const key of Object.keys(PATH_OBJECTS)) {
        if ((clean === key || clean.startsWith(`${key}/`)) && (!best || key.length > best.length)) best = key;
    }
    return best ? PATH_OBJECTS[best] : null;
}

/** null — права не включены (решает роль ERP); true/false — решение по правам. */
export function pathAllowedByRights(path, grants = current.grants, on = current.on) {
    if (!on) return null;
    const objects = objectsForPath(path);
    if (!objects || !objects.length) return true;
    return objects.some((o) => canView(o, grants));
}
